import { Pipe, PipeTransform } from '@angular/core';

const OPERATION_TYPE_LABELS: Record<string, string> = {
  CASH_IN: 'Collect',
  CASH_OUT: 'Payment',
};

@Pipe({ name: 'operationType' })
export class OperationTypePipe implements PipeTransform {
  transform(value: string): string {
    return OPERATION_TYPE_LABELS[value] ?? value;
  }
}